import React, {ReactNode} from 'react'
import {StyledDiv} from '../../../../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {Box} from '@mui/material'
import {ApplyTitle, FirstPageDiv, HeaderArea, HeaderAreaBox} from './NatAdminApplicatioPrintCommonStyle'
import {RESIDENT_APPLY_PROCESS, RESIDENT_APPLY_STATUS} from '../../../../../../CodeMaster'
import {getPrintDate} from '../../helper/NatApplicationHelper'
import {NatSealField, SealField} from './NatSealField'
import {NatConstructionCompleteDetail} from '../../../repository/NatGetConstructionComplete'
import {convertToRoomNumberForResident} from '../../../../../common/util/Natutil'
import {ApplyStatusInfo} from '../../../repository/NatGetApplicationStatus'
import moment from 'moment'
import {NatEncloseInParenthesis} from './NatEncloseInParenthesis'

interface Props {
    constructionCompleteApplicationDocumentParam: NatConstructionCompleteDetail
    applyStatusInfoList: ApplyStatusInfo[]
}

export const NatConstructionCompleteApplicationDocument: React.FC<Props> = props => {
    const {
        constructionCompleteApplicationDocumentParam,
        applyStatusInfoList
    } = props

    const {
        applyId, condominiumName,ridgeName, roomNumber,
        applicantFamilyName, applicantFirstName, contractorName, constructionCompleteDate
    } = constructionCompleteApplicationDocumentParam

    const applicantRoom = `${ridgeName} ${convertToRoomNumberForResident(roomNumber)}`
    const applicantName = `${applicantFamilyName} ${applicantFirstName}`

    return (<>
        <FirstPageDiv>
            <HeaderArea>
                <HeaderAreaBox>
                    <Box ml={'auto'} mt={'10mm'}>申請ID：{applyId}</Box>
                </HeaderAreaBox>
                <HeaderAreaBox>
                    <Box m={'auto'}><ApplyTitle>工事完了届</ApplyTitle></Box>
                </HeaderAreaBox>
                <HeaderAreaBox>
                    <Box ml={'auto'} mt={'3mm'}>
                        {renderSealField(applyStatusInfoList)}
                    </Box>
                </HeaderAreaBox>
            </HeaderArea>
            <Box ml={'25mm'} mt={'3mm'}>
                理事長殿
            </Box>
            <Box ml={'30mm'} mt={'5mm'} whiteSpace={'pre-wrap'}>
                　下記をもって、改修工事が申請どおりの内容で完了したことを報告いたします。
            </Box>
            <Box margin={'3mm 0 0 30mm'} display={'flex'} flexDirection={'column'} width={'130mm'}>
                <Box>
                    <Box mb={'5mm'} whiteSpace={'pre-wrap'}>1  申請者</Box>
                    <Box ml={'8mm'} mb={'5mm'}>
                        {renderApplicationDetail('マンション名', condominiumName)}
                        {renderApplicationDetail('部屋番号', applicantRoom)}
                        {renderApplicationDetail('氏名', applicantName)}
                    </Box>
                </Box>
                <Box>
                    <Box mb={'5mm'}>
                        {renderApplicationDetail('2  工事施工者', contractorName)}
                    </Box>
                </Box>
                <Box>
                    <Box mb={'5mm'}>
                        {renderApplicationDetail('3  工事完了日', renderDate(constructionCompleteDate))}
                    </Box>
                </Box>
            </Box>
        </FirstPageDiv>
    </>)

    NatConstructionCompleteApplicationDocument.displayName = 'NatConstructionCompleteApplicationDocument'
}

const renderApplicationDetail = (title: string, value: string | ReactNode) => {
    return (
        <PrintApplicationDetailContainer>
            <Box whiteSpace={'pre-wrap'}>{title}</Box>
            <NatEncloseInParenthesis item={value}/>
        </PrintApplicationDetailContainer>
    )
}

const renderDate = (date: string) => {
    const value = getPrintDate(date)

    return (
        <>
            <Box component={'span'} padding={'0 3mm 0 1mm'}>{value.year}</Box>年
            <Box component={'span'} padding={'0 4mm 0 4mm'}>{value.month}</Box>月
            <Box component={'span'} padding={'0 4mm 0 4mm'}>{value.day}</Box>日
        </>
    )
}

const renderSealField = (applyStatusInfoList: ApplyStatusInfo[]) => {
    const sealFields: SealField[] = applyStatusInfoList.map((info) => {
        const applyStatusEnum = RESIDENT_APPLY_PROCESS.codeToEnumConstants(info.applyProcess)
        let seal
        if (info.applyStatus === RESIDENT_APPLY_STATUS.REJECTION.value) {
            seal = '却下'
        } else {
            seal = info.actual.registerDatetime ? moment(info.actual.registerDatetime).format('YYYY/M/D') : ''
        }
        return {
            applyStatus: applyStatusEnum.label,
            seal: seal,
            sortOrder: applyStatusEnum.displayOrder
        }
    })

    return (
        <NatSealField sealFields={sealFields}/>
    )
}

const PrintApplicationDetailContainer: StyledDiv = styled.div`
  display: flex;
  width: 100%;
`
